
import "./LogoLoader.css";

const BLUE_BODY =
  "M84 141V120C84 105 92 91 107.2 86A24 24 0 0 0 137.8 86C153 91 161 105 161 120V141H137V120A14.5 14.5 0 0 0 108 120V141Z";

const WHITE_BODY =
  "M31 140V121C31 106 40 92 55.5 87A24 24 0 0 0 83.5 87C98.5 92 108 106 108 121V140H84V120A14.5 14.5 0 0 0 55 120V140Z";

export function LogoLoader({
  size,
  variant = "orbit",
  theme = "dark",
  label = "Loading",
  className = "",
}) {
  const px =
    size ?? (variant === "mini" ? 40 : variant === "pulse" ? 112 : 176);

  const style = {
    "--ll-size": `${px}px`,
  };

  return (
    <div
      role="status"
      aria-label={label}
      className={`logo-loader ll-v-${variant}${theme === "light" ? " on-light" : ""} ${className}`}
      style={style}
    >
      {variant !== "mini" && (
        <>
          <span className="ll-pulse" />
          <span className="ll-pulse" />
          <span className="ll-pulse" />
        </>
      )}

      {variant === "orbit" && (
        <svg
          className="ll-orbit"
          viewBox="0 0 176 176"
          aria-hidden="true"
        >
          <circle
            cx="88"
            cy="88"
            r="82"
            fill="none"
            stroke="var(--ll-track)"
            strokeWidth="3"
          />

          <g className="ll-arc">
            <circle
              cx="88"
              cy="88"
              r="82"
              fill="none"
              stroke="var(--ll-accent)"
              strokeWidth="3.5"
              strokeLinecap="round"
              strokeDasharray="130 400"
            />
          </g>
        </svg>
      )}

      <svg
        className="ll-mark"
        viewBox="27 47 138 98"
        aria-hidden="true"
      >
        <g className="ll-person b">
          <circle
            cx="122.5"
            cy="67.5"
            r="16.5"
            fill="var(--ll-accent)"
          />
          <path d={BLUE_BODY} fill="var(--ll-accent)" />
        </g>

        <g className="ll-person">
          <circle
            cx="69.5"
            cy="67.5"
            r="15.5"
            fill="var(--ll-fg)"
          />

          <path
            d={WHITE_BODY}
            fill="none"
            stroke="var(--ll-bg)"
            strokeWidth="3.5"
            strokeLinejoin="round"
          />

          <path d={WHITE_BODY} fill="var(--ll-fg)" />
        </g>
      </svg>
    </div>
  );
}

export default LogoLoader;
